import Service from "../../AuthService";

const BillingRE = {
    getBillingRE(page) {
        return Service.get("/billing-re?page="+page)
    },
    showBillingRE(id){
        return Service.get("/billing-re/"+id);
    },
    createBillingRE(data){
        return Service.post("/billing-re",data)
    },
    updateBillingRE(id,data){
        return Service.put("/billing-re/"+id,data)
    },
    searchBillingRE(data){
        return Service.post("/search_billing_re?page="+data.page,data);
    },
    deleteBillingRE(id){
        return Service.delete("/billing-re/"+id);
    }
};

export default BillingRE
